import sub from 'root/src/aws/util/sub'
import { GATEWAY_REST_API } from 'root/src/aws/gateway/resourceIds'

export const REST_STAGENAME = 'v1'
export const WEBSOCKETS_STAGENAME = 'v1'

export const GATEWAY_URL_OUTPUT_SUB = sub(
	`https://\${${GATEWAY_REST_API}}.execute-api.\${AWS::Region}.amazonaws.com/${REST_STAGENAME}/`,
)
